import axios from "../utils/axios.wrapper";

export const getAllPathologies = async () => {
  const response = await axios.get('/Pathology');
  return response.data.items || response.data.Items || [];
};

export const createPathologyApi = async (payload) => {
  const response = await axios.post('/Pathology/create', payload);
  return response.data;
};

export const updatePathologyApi = async (id, payload) => {
  await axios.put(`/Pathology/${id}`, payload);
  return { id, payload };
};

export const deletePathologyApi = async (id) => {
  await axios.delete(`/Pathology/${id}`);
  return id;
};

export const pathologyService = {
  getAllPathologies,
  createPathology: createPathologyApi,
  updatePathology: updatePathologyApi,
  deletePathology: deletePathologyApi,
};